import {AdminEN} from "./admin/en";

export const SystemEN = {
    ...AdminEN
}